<template>
    <div class="sure_order full">
        <!-- <div class="full takeBlood_address" v-show="!show">
            <van-area :area-list="areaList" columns-num="2" @confirm="confirm" @cancel="cancel" :value="areaCode"/>
        </div> -->

        <div v-show="show" class="main">
            <!-- 导航栏 -->
            <tabbar msg="确认订单"></tabbar>
            <!-- 登录 -->
            <sign v-on:opt="opt" v-if="sign" :msg="msg" style="padding-top: 24px;padding-bottom: 24px; margin-bottom: 10px;"></sign>
            <!-- 地址 -->
            <div :class="{adress: true, adress_sign: sign || !$store.state.curAddress.addressId}" :data-addressId="$store.state.curAddress.addressId" v-if="curGoods.goodsType == 2" @click="adressList" :style="sign? 'padding: 18px;border-bottom: 1px solid #f5f5f5;': 'margin-bottom: 10px;'">
                <img :src="$store.state.api.imgUrl + 'adress.png'" alt="" class="img1">
                <div v-if="sign || !$store.state.curAddress.addressId" class="sign_tip text_size11 text_color333">请填写收货地址</div>
                <div class="comtent" v-if="!sign && $store.state.curAddress.addressId">
                    <div class="comtent1">
                        <span v-text="$store.state.curAddress.receiver" class="text_size11 text_color333 sp1"></span>
                        <span v-text="$store.state.curAddress.phone" class="text_size11 text_color333 sp2"></span>
                    </div>
                    <div class="text_size11 text_color333 comtent2" v-text="$store.state.curAddress.address"></div>
                </div>
                <img :src="$store.state.api.imgUrl + 'right.png'" alt="" class="img2">
            </div>
            <!-- 采血信息 -->
            <div class="takeBlood" v-if="curGoods.goodsType == 1 && !sign">
                <div class="text_size12 text_color000 title">采血信息</div>

                <div class="takeBlood_n">
                    <div class="text_size10 text_color000">采血人：</div>
                    <input type="text" v-model="takeBlood_n">
                </div>

                <div class="takeBlood_n">
                    <div class="text_size10 text_color000">电话：</div>
                    <input type="text" v-model="takeBlood_t">
                </div>

                <p class="tipText">请注意填写真实手机号，以获取检测项目报告推送提醒。</p>
<!-- 
                <div class="adress2">
                    <div class="text_size10 text_color000">采血点：</div>
                    <div class="text_size10 text_colorbbb area area1" ref="area1" @click="tj" v-text="bloodProvince"></div>
                    <div class="text_size10 text_colorbbb area area2" ref="area2" @click="tj" v-text="bloodCity"></div>
                </div> -->

                <!-- <div class="tj">
                    <button @click="tj">提交</button>
                </div> -->
            

                <!-- <van-cell-group>
                    <van-field v-model="takeBlood_n" placeholder="" label="采血人"/>
                </van-cell-group>

                <van-cell-group>
                    <van-field v-model="takeBlood_p" placeholder="" label="电话" type="tel"/>
                </van-cell-group>

                <div>
                    <van-area :area-list="areaList" :columns-num="2" :visible-item-count="1"/>
                </div> -->
                <!-- 
                <van-address-edit
                    :address-info="addressInfo"
                    :area-list="areaList"
                    :search-result="searchResult"
                    @save="onSave"
                    @change-detail="onChangeDetail"
                /> -->



            </div>
            <!-- 订单商品 -->
            <div class="goods">
                <img :src="curGoods.goodImages[0]" alt="">
                <div class="text">
                    <h3 class="text_color333 text_size14" v-text="curGoods.goodsName"></h3>
                    <span class="text_color2 text_size12" v-text="'类型：' + curGoods.goodsClassName"></span>
                    <p class="text_size16 text_color0"><em class="text_size13">￥</em>{{(curGoods.channelPriceStr + '').split('.')[0]}}<span class="text_color0 text_size12" v-text="curGoods.channelPriceStr.split('.')[1] ? '.' + curGoods.channelPriceStr.split('.')[1] : ''"></span></p>
                </div>
                <div class="number">
                    <span data-msg="-" @click="getNumber('-')" class="text_size13 text_color999 s1">-</span>
                    <span v-text="number" class="text_size10 text_color999"></span>
                    <span data-msg="+" @click="getNumber('+')" class="text_size13 text_color999 s1">+</span>
                </div>
            </div>
			
            <!-- 配送 -->
            <div class="kd" v-if="curGoods.goodsType == 2">
                <span class="text_size12 text_color333">配送方式</span>
                <span class="text_size12 text_color999" v-text="'顺丰包邮'"></span>
            </div>
			<!--备注-->
			<div class="remark">
				<span>订单备注</span>
				<input class="remark_text" v-model="remarkmain" type="text" placeholder="选填">
			</div>
            <!--知情同意书 -->
            <div class="letter">
               <van-checkbox v-model="checked">已阅读并同意 <span @click="letter" class="blutfont">《知情同意书》</span></van-checkbox>             
            </div>
			
            <div class="box"></div>
            <!-- 小姐 -->
            <div class="bot">
                <div class="l">
                    共计{{number}}件商品：<span class="text_size16 text_color0"><em class="text_size12">￥</em>{{(curGoods.channelPriceStr * 100 * number /100 + '').split('.')[0]}}<span class="text_color0 text_size12" v-text="(curGoods.channelPriceStr * 100 * number /100 + '').split('.')[1] ?　'.' + (curGoods.channelPriceStr * 100 * number /100 + '').split('.')[1] : ''"></span></span>
                </div>
                <div class="text_size16 text_colorfff bg_color0 r" @click="pay" :style="sure_order()? '' : 'background-color: #999999;' ">提交订单</div>
            </div>
        </div>

        
    </div>
        
</template>
<script>
    import './sure_order.scss';
    import sign from '@/components/sign/sign.vue';
    import qs from 'qs';
    import api from '@/utils/js/api';
    import areaList from '@/utils/js/address';
    import { Checkbox, CheckboxGroup } from 'vant';
    //Vue.use(Checkbox).use(CheckboxGroup);

    export default {
    	//
        data(){
            return {
                show: true,
                // 是否需要登录
                sign: false,
                userInfo:'',
                goodsId: '',
                number: 1,
                userId:'',
                token: '',
                // 地址列表
                areaList: areaList,
                // 默认地址
                curAddress:'',
                // 采血人
                takeBlood_n: '',
                // 电话
                takeBlood_t: '',
                // 采血人city
                // takeBlood_c: [],
                // bloodProvince: '点击选择所在省份>',
                // bloodCity: '点击选择所在城市>',
                //采血信息地址
                // areaList: areaList,
                areaCode: '',
                // 登录按钮文字
                msg: '登录',
                show_bot: false,
                // 当前商品（订单）
                // curGoods: ''，
				//用户备注
				remarkmain:'',
                checked: false,
            }
        },

        components: {
            sign
        },
        created(){
            this.goodsId = this.$route.query.goodsId || this.$store.state.goodsId;
            // var a = this.$store.state.curGoods;
            // a.goodsType = 1;
            this.curGoods = this.$store.state.curGoods;
            
            this.$store.commit('getUserInfo');
            this.userInfo = this.$store.state.userInfo || '';
            //若用户信息带有采血信息，则默认填入
            if(this.userInfo.bloodPhone){
                this.takeBlood_t = this.userInfo.bloodPhone;
                this.takeBlood_n = this.userInfo.bloodName;
                // this.bloodProvince = this.userInfo.bloodProvince;
                // this.bloodCity = this.userInfo.bloodCity;
                // this.takeBlood_c[0] = 1;
            }

            if(this.$store.state.curAddress.addressId){
                console.log('created-if',this.$store.state.curAddress);
                this.curAddress = this.$store.state.curAddress;
            }
            
            if(this.userInfo.userId){
                // if(!this.userInfo.phone){
                //     this.sign = true;
                //     this.msg = "绑定手机";
                // }else{
                //     this.queryAddressList();
                // }
                this.queryAddressList();
            }
            // else{
            //     this.sign = true;
            // }
            // console.log('goodsId',this.goodsId, this.curGoods.goodsType, this.sign);

        },
        beforeUpdate(){
        },
        beforeMount(){
            // setTimeout(()=>{
            //     this.opt();
            // },5000)

            // window.onload=function(){ //在页面整体加载完毕时
            //    this.show_bot = !this.show_bot;
            // }; 
        },
        // computed: {
        //     curGoods(){
        //         console.log('测试vuex');
        //         return this.$store.state.curGoods
        //     }
        // },
        methods: {
            // 是否可以提交订单
            sure_order(){
                // if(this.sign) return false;
                if(this.curGoods.goodsType == 2 && this.userInfo.userId && this.$store.state.curAddress.addressId) return true;
                if(this.curGoods.goodsType == 1 && this.takeBlood_n && this.regTel(this.takeBlood_t)) return true;
                return false;
            },
            // 手机号正则
            regTel(phone){
                if(!(/^1[34578]\d{9}$/.test(phone))){ 
                    return false; 
                }else{
                    return true;
                }
            },
            // 登录成功后操作queryAddressList(干血) showTakeBlood(全血)
            opt(){
                this.sign = false;
                if(!this.userInfo.userId){
                    this.userInfo = this.$store.state.userInfo;
                }
                console.log(this.userInfo);
                if(this.curGoods.goodsType == 1){
                    this.showTakeBlood();
                }else if(this.curGoods.goodsType == 2){
                    this.queryAddressList();
                }
                
            },
            // 显示采血信息收集栏(全血)
            showTakeBlood(){      
                this.sign = false;
                console.log('showTakeBlood-全血',this.curGoods.goodsType == 1 && !this.sign);
            },
            // 查询地址列表(干血)
            queryAddressList(){
                console.log('queryAddressList-干血');
                var that = this;
                this.$http({
                    url: api.queryAddressList,
                    method: 'post',
                    data: {
                        userId: this.userInfo.userId,
                        token: this.userInfo.token
                    }
                }).then(res=>{
                    console.log('queryAddressList',res.data)
                    if(res.success && res.code != 3000){
                        res.data.forEach(item => {
                            if(item.isdefault == '1'){
                                that.curAddress = item;
                                that.$store.commit({
                                    type: 'comment',
                                    name: 'curAddress',
                                    curAddress: item
                                })
                            }
                        });
                        this.address = res.data;
                        this.$store.commit({
                            type: 'comment',
                            name: 'address',
                            address: res.data
                        })
                        
                    }else if(res.code == 3000){
                        this.sign = true;
                        this.userInfo = '';
                        this.$toast(res.message);
                    }
                })
            },
            //设置数量
            getNumber(msg){
                console.log(msg);
                if(msg == '-'){
                    if(this.number < 2) return;
                    this.number = this.number - 1;
                    
                }else if(msg == '+'){
                    this.number = this.number*1 + 1;
                }
                
            },
            // 地址
            adressList(){
                if(!this.userInfo) return this.$toast('请先登录');
                // if(this.sign) return this.$toast('请绑定手机号');
                this.$router.push({
                    name: 'address',
                    params: {
                        target: 'sure_order'
                    }
                })
            },
            confirm(data){
                console.log(data);
                this.takeBlood_c = data;
                this.isShow();
                this.$refs.area1.innerText = data[0].name;
                this.$refs.area2.innerText = data[1].name;
            },
            cancel(){
                this.isShow();
            },
            isShow(){
                this.show = !this.show;
            },
            //提交采血信息
            tj(){
                this.isShow();
            },
            // 知情同意书
            letter(){
                // if(this.sign) return this.$toast('请绑定手机号');
                this.$router.push({
                    name: 'letter',
                    params: {
                        target: 'letter/letter'
                    }
                })
            },
            //提交订单
            pay(){
            	
                console.log(this.userInfo.userId,this.$store.state.curAddress)
                if(!this.checked) return this.$toast('请阅读并同意《知情同意书》');
                if(!this.userInfo.userId) return this.$toast('登录信息有误，请检查');
                var data = {
                    goodsId: this.goodsId,
                    goodsNum: this.number,
                    channelId: this.$store.state.channelId,
					userRemark:this.remarkmain,
                }
				//return
                if(this.curGoods.goodsType == 2) {
                    if(!this.$store.state.curAddress.addressId) return this.$toast('提交失败，请检查');
                    data.addressId = this.$store.state.curAddress.addressId;
                }else if(this.curGoods.goodsType == 1){
                    if(!this.takeBlood_n) return this.$toast('请完善采血信息');
                    if(!this.regTel(this.takeBlood_t)) return this.$toast('请输入正确的手机号');
                    data = Object.assign(data, {
                        bloodPhone: this.takeBlood_t,
                        bloodName: this.takeBlood_n,
                        // bloodProvince: this.$refs.area1.innerText,
                        // bloodCity: this.$refs.area2.innerText
                    }) 
                }else{
                    setTimeout(()=>{
                        this.$router.replace({
                            name: 'index'
                        },1500)
                    })
                    return this.$toast('商品类型有误，请检查');

                }

                this.$http({
                    url: api.submitOrder,
                    method: 'post',
                    data: data
                }).then(res=>{
                    if(res.success){
                        if(this.curGoods.goodsType == 1){
                            var userInfo = JSON.parse(localStorage.getItem('userInfo'));
                            userInfo.bloodPhone = data.bloodPhone;
                            userInfo.bloodName = data.bloodName;
                            // userInfo.bloodProvince = data.bloodProvince;
                            // userInfo.bloodCity = data.bloodCity;
                            localStorage.setItem('userInfo', JSON.stringify(userInfo));
                            this.$store.commit({type: 'getUserInfo',must: true});
                        }
                        // window.location.href = window.location.host +  '/h5/pay?order' + res.data.orderNo;
                        this.$router.replace({
                            name: 'pay',
                            query: {
                                orderNo: res.data.orderNo,
                                goBack: -2
                            }
                        })
                    }else{
                        this.$toast(res.message);
                    }
                })
            }
        }
    }
</script>

